// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.locations.RentalManagerPropertyLocationRestrictionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, ListingType, PropertyLocationRestrictionsResponseWebDto } from '../..';

interface RestrictionsParams {
  fullAddress: string;
  listingAlias?: ListingAlias;
  listingType: ListingType;
  unit?: string;
}

export const RentalManagerPropertyLocationRestrictionsWebApiHandler_restrictions_Path =
  '/api/web/v1/properties/locations/restrictions';

/**
 * Get location restrictions for a property by address and listing type for non logged-in users
 */
export const RentalManagerPropertyLocationRestrictionsWebApiHandler_restrictions = (
  getParams: RestrictionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RestrictionsParams, never, PropertyLocationRestrictionsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerPropertyLocationRestrictionsWebApiHandler_restrictions_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
